exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/SettingsModal/WidgetCard/WidgetCard.scss
 ** module id = 761
 ** module chunks = 0
 **/